import {
  FormField,
  FormFieldSelect
} from '../Form';

import {
  // Number
  FilterRenderNumber,
  FilterCreatorNumber,
} from '../Filters';

const valueFormatter = (value) => {
  if (typeof value === 'undefined' || value === null || isNaN(value)) {
    return null; // or return another appropriate default value when the input is undefined, null, or not a valid number.
  }

  try {
    const parsedValue = parseInt(value, 10); // Convert the value to an integer.
    return isNaN(parsedValue) ? null : parsedValue; // Return the parsed value if it is a valid number, or another default value if the parsing fails.
  } catch (error) {
    console.error('Error occurred while formatting value:', error); // Log the error for debugging purposes.
    return null; // or return another appropriate default value if an error occurs during parsing.
  }
};

export default {
  Render(props) {
    const {
      fieldName,
      taxonomyType,
      overrideParams = {},
      fieldsRequired
    } = props;
    const _taxonomyType = taxonomyType?.data || taxonomyType;
    const title = _taxonomyType?.name;
    // const design = _taxonomyType?.style?.design
    const _fieldName = fieldName || _taxonomyType?.nameSlug;
    const param = { ..._taxonomyType?.param, ...overrideParams, title, fieldsRequired, formatter: valueFormatter };
    const style = param?.style;

    return (
      <FormField
        name={_fieldName}
        type="number"
        {...param}
        {...style}
        {...props}
        placeholder="Autogenerado"
        disabled={true}
      />
    );
  },
  
  RenderFilter(props) {
    return <FilterRenderNumber {...props} DataTypeRender={this.Render} />
  },

  RenderFilterParam(props) {
    return <FilterCreatorNumber {...props} />
  },

  valueFormatter,

  RenderInputParams: ({ values, param }) => (null),

  RenderShowConditionParams: ({ values, taxonomyToWatch }) => (
    <>
      <FormFieldSelect
        name="show.number.operator"
        title="Operador"
        placeholder="Operador"
        options={[
          { value: 'eq', label: 'es igual' },
          { value: 'gt', label: 'es mayor' },
          { value: 'lt', label: 'es menor' }
        ]}
      />
      {values.show?.number?.operator ? (
        <FormField
          type="number"
          name="show.number.value"
          title="Valor"
          placeholder="valor"
        />
      ) : ''}
    </>
  ),

  RenderStyleParams: ({ values }) => (null),

  RenderTaxonomyTypePreview: ({ values, formFieldProps }) => (null)
}